import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';

if (process.env.NODE_ENV == 'production') {
    enableProdMode();
}

// Boot the application, either now or when the DOM content is loaded
// const platform = platformBrowserDynamic();
// const bootApplication = () => platformBrowserDynamic().bootstrapModule(AppModule);
// if (document.readyState == 'complete') {
//     platformBrowserDynamic().bootstrapModule(AppModule);
// } else {
//     document.addEventListener('DOMContentLoaded', bootApplication);
// }

platformBrowserDynamic().bootstrapModule(AppModule);


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/main.ts